import StoreHelper from '../../../store/helper'
import PositionManager from '../../PositionManager'

import { DraggablePlaceholder } from '../index'

export const onDragover = (e) => {
  e.preventDefault()
  // Prevent dragleave logic to be called multiple times
  if (StoreHelper.isDropTargetDefined()) return
  StoreHelper.setDropTarget(e.target)
  const dropPositionIndex = PositionManager.getPositionConsideringPagination(StoreHelper.getDropTargetIndex(e.target, true))
  StoreHelper.addDragElement(StoreHelper.getActiveViewKey(), DraggablePlaceholder, dropPositionIndex)

  PositionManager.recalculateDropTargetPositions()
}
